import React, { useState, useEffect, useRef } from "react";
import ResponsivasIcon from "@mui/icons-material/AssignmentOutlined";
import { Badge, Box, Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IsMobile } from "../../utils/utils";
import { useDispatch } from "react-redux";
import { showResponsivasReducer } from "../../store/reducers/app";
import { getPendingResponsives } from "../../store/actions/responsives";

const REFRESH_INTERAL = 300000; //5MIN

const ResponsivasNavBarButton = () => {
  const { t } = useTranslation();
  const isMobile = IsMobile();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [pendingResponsives, setPendingResponsives] = useState(0);

  const refreshIntervalRef = useRef(null);

  useEffect(() => {
    refreshHandler();
    startRefreshIntervalHandler();
    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, []);

  const startRefreshIntervalHandler = () => {
    refreshIntervalRef.current = setInterval(refreshHandler, REFRESH_INTERAL);
  };

  const refreshHandler = () => {
    setLoading(true);
    getPendingResponsives()
      .then((r) => {
        setPendingResponsives(r);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showResponsivasHandler = () => {
    dispatch(showResponsivasReducer(true));
  };

  return (
    <Button
      onClick={showResponsivasHandler}
      className="mr-3 btn-responsivas-management"
      variant="contained"
      color="secondary"
    >
      {loading && <CircularProgress size={24} className="mr-2" />}
      {!loading && <ResponsivasIcon className={!isMobile ? "mr-2" : ""} />}
      {t("userManagement.responsivas")}
      {pendingResponsives > 0 && (
        <Box className="ml-2 pl-2 pr-2" sx={{ backgroundColor: "#f44336", color: "#fff", borderRadius: "4px" }}>
          {pendingResponsives}
        </Box>
      )}
    </Button>
  );
};

export default ResponsivasNavBarButton;
